import Cookies from "js-cookie";

const ACCESS_TOKEN_KEY = "a_token";
const REFRESH_TOKEN_KEY = "reToken";
const USER_TYPE_KEY = "User_type";
const LOGIN_STATUS_KEY = "loginStatus";

export function getAccessToken() {
  return Cookies.get(ACCESS_TOKEN_KEY);
}

export function hasAccessToken() {
  return Boolean(getAccessToken());
}

export function clearAuthStorage() {
  Cookies.remove(ACCESS_TOKEN_KEY);
  Cookies.remove(REFRESH_TOKEN_KEY);
  Cookies.remove(USER_TYPE_KEY);
  Cookies.remove(LOGIN_STATUS_KEY);
}
